import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    cardsContainer: {
      marginTop: '32px',
    },
  };
});
